import React from "react";
import "./PianoDialog.css";
import LimitedCharactersDialog
    from "../../../../../../shared/components/dialogs/limited-characters-dialog/LimitedCharactersDialog";
import PropTypes from "prop-types";

const PianoDialog = (props) => {
    return (
        <LimitedCharactersDialog
            open={props.open}
            characterLimit={1000}
            screenCode={props.screenCode}
            handleDialogClose={props.handleDialogClose}
            handleDialogCloseButton={props.handleDialogCloseButton}
            sims={props.sims}
            checkActiveSr={props.checkActiveSr}
            title={
                "Richiedi modifica del piano per " +
                (props.sims.length === 1 ? `la SIM ${props.sims[0].numeroDiTelefono}` : `${props.sims.length} SIM`)
            }
            subtitle={"Puoi richiedere la variazione del piano di queste SIM tramite il Servizio Clienti"}
        />
    );
};

PianoDialog.propTypes = {
    open: PropTypes.bool.isRequired,
    handleDialogClose: PropTypes.func.isRequired,
    handleDialogCloseButton: PropTypes.func.isRequired,
    sims: PropTypes.array.isRequired,
    checkActiveSr: PropTypes.bool.isRequired
};

PianoDialog.defaultProps = {
    checkActiveSr: false
};

export default PianoDialog;
